// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "payments-2mVqg";
var _4 = "payments__title-Mok7X";
var _5 = "payments__content-2fHMz";
var _6 = "payments__contentText-reAlk";
var _7 = "payments__button-i_cEe";
export { _1 as "__esModule", _2 as "mobile", _3 as "payments", _4 as "payments__title", _5 as "payments__content", _6 as "payments__contentText", _7 as "payments__button" }
export default { "__esModule": _1, "mobile": _2, "payments": _3, "payments__title": _4, "payments__content": _5, "payments__contentText": _6, "payments__button": _7 }
